import { type FC } from "react";

import { Label } from "@/shared/components/ui/label";
import { FieldError } from "@/shared/components/ui/FieldError";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { ONBOARDING_RELATIONSHIP_OPTIONS } from "@/shared/constants/relationshipOptions";

interface RelationshipSelectProps {
  name: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export const RelationshipSelect: FC<RelationshipSelectProps> = ({
  name,
  value,
  onChange,
  error,
}) => {
  return (
    <div>
      <Label htmlFor="relationship">{name ? `I am ${name}'s...` : "I am their..."}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger id="relationship" className={error ? "border-destructive border-[2px]" : ""}>
          <SelectValue placeholder="Select a relationship" />
        </SelectTrigger>
        <SelectContent>
          {ONBOARDING_RELATIONSHIP_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error && <FieldError message={error} className="mt-1" />}
    </div>
  );
};
